import { Person } from '@mui/icons-material'
import {
  Box,
  Button,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography,
} from '@mui/material'
import { FunctionComponent, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { useCreateExternalUserMutation, useUsersQuery } from 'services/users'
import { IUser } from 'types/users'

export const DeactivatedUsers: FunctionComponent = () => {
  const { t } = useTranslation()
  const [name, setName] = useState<string>('')

  const { data, isLoading, isError, refetch } = useUsersQuery(
    { active: 'false', name },
    {
      refetchOnMountOrArgChange: true,
    }
  )

  const [
    createUser,
    {
      isLoading: isLoadingActivate,
      isError: isErrorActivate,
      isSuccess: isSuccessActivate,
    },
  ] = useCreateExternalUserMutation()

  const { register, handleSubmit } = useForm<{ name: string }>({
    defaultValues: {
      name: '',
    },
  })

  useEffect(() => {
    if (isSuccessActivate) {
      toast.success(t('operation-success'))
    }
  }, [isSuccessActivate, t])

  const onSubmit = (values: { name: string }) => {
    setName(values.name)
  }

  const handleActivate = (user: IUser) => {
    createUser({ ...user, active: true })
  }

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
          gap={2}
        >
          <TextField
            InputLabelProps={{ shrink: true }}
            size="small"
            fullWidth
            placeholder={t('search-based-on-name')}
            {...register('name', { required: t('required'), minLength: 3 })}
          />
          <Button
            type="submit"
            variant="contained"
            style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
          >
            {t('search')}
          </Button>
        </Box>
        <List>
          {data?.items.map((user) => {
            return (
              <ListItem
                key={user.id}
                secondaryAction={
                  <IconButton
                    onClick={() => handleActivate(user)}
                    edge="end"
                    aria-label="activate"
                  >
                    <Person color="success" />
                  </IconButton>
                }
              >
                <ListItemText>
                  <Box display="flex" alignItems="center" gap={5}>
                    <Typography fontWeight="bold" variant="subtitle1">
                      {user?.firstName + ' ' + user?.lastName}
                    </Typography>
                    <Typography>
                      {user?.userRoles.map((role) => t(role)).join(', ')}
                    </Typography>
                  </Box>
                </ListItemText>
                <Divider component={'li'} />
              </ListItem>
            )
          })}
        </List>
      </form>
    </div>
  )
}
